module.exports = __webpack_public_path__ + "media/images/favicons_staging/mstile-70x70-0c5339c6e9f1532a67b208b743bef395.png";